import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function BookAnAppointment() {
  return <section data-section-id="177891" id="call-to-action" className="bg-primary text-primary-foreground py-24 sm:py-32 px-6 lg:px-8 flex flex-col items-center justify-center text-center">
      <div className="max-w-2xl flex flex-col items-center gap-6">
        <h2 className="text-4xl sm:text-5xl font-serif text-primary-foreground tracking-normal">
          Begin Your Path to Better Health
        </h2>
        
        <p className="text-lg leading-8 text-primary-foreground/90 font-sans">
          Our specialists in Limassol and Nicosia are dedicated to providing personalized care tailored to your unique needs. Start your journey toward recovery and wellness with us today.
        </p>
        
        <div className="mt-4">
          <Button asChild size="lg" className="bg-accent text-accent-foreground hover:bg-accent/90 rounded-full shadow-xl">
            <Link to="/ContactPage">
              Schedule a Consultation
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}